import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { financialRecordAddressNameFields } from 'constants/enums/people';
import { FinancialBankruptcyModel } from './types';
import { financialBankruptcyItemValidator } from './validators/item';

const financialBankruptcyValidator: ValidateJSModel<FinancialBankruptcyModel> = {
  HasBankruptcy: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasBankruptcy?.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, financialRecordAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: financialBankruptcyItemValidator },
      };
    }

    return {};
  },
};

export default financialBankruptcyValidator;
